import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from "../@shared/shared.module";

import { PagesRoutingModule } from './pages-routing.module';
import { LayoutComponent } from '../layout/layout.component';
import { FormsModule } from '@angular/forms';
import { FooterComponent } from '../layout/footer/footer.component';
import { SidebarComponent } from '../layout/sidebar/sidebar.component';
import { UpcomingComponent } from '../layout/upcoming/upcoming.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ICasinoComponent } from './dashboard/i-casino/i-casino.component';
import { SportListComponent } from './sport-list/sport-list.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { RulesComponent } from './rules/rules.component';
import { InPlayComponent } from './in-play/in-play.component';
import { MyBetListComponent } from './my-bet-list/my-bet-list.component';
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component';
import { MarketAnalysisComponent } from './market-analysis/market-analysis.component';
import { MultiMarketComponent } from './multi-market/multi-market.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { UpdateProfileComponent } from './user/update-profile/update-profile.component';
import { UserCreateComponent } from './user/user-create/user-create.component';
import { ExposeDetailComponent } from './user/expose-detail/expose-detail.component';
import { CasinoSettingComponent } from './settings/casino-setting/casino-setting.component';
import { ICasinoSettingComponent } from './settings/i-casino-setting/i-casino-setting.component';
import { SportSettingComponent } from './settings/sport-setting/sport-setting.component';
import { UserSettingComponent } from './settings/user-setting/user-setting.component';
import { DepositComponent } from './deposit/deposit.component';
import { WithdrawComponent } from './withdraw/withdraw.component';
import { SettlementComponent } from './settlement/settlement.component';
import { RaceListComponent } from './race-list/race-list.component';
import { RemovedUsersComponent } from './user/removed-users/removed-users.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';


@NgModule({
  declarations: [
    LayoutComponent,
    SidebarComponent,
    UpcomingComponent,
    DashboardComponent,
    ICasinoComponent,
    SportListComponent,
    MyProfileComponent,
    RulesComponent,
    InPlayComponent,
    MobileMenuComponent,
    MarketAnalysisComponent,
    MultiMarketComponent,
    UserListComponent,
    UpdateProfileComponent,
    UserCreateComponent,
    ExposeDetailComponent,
    CasinoSettingComponent,
    ICasinoSettingComponent,
    SportSettingComponent,
    UserSettingComponent,
    DepositComponent,
    WithdrawComponent,
    SettlementComponent,
    RaceListComponent,
    RemovedUsersComponent
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    FormsModule,
    SharedModule,
    LazyLoadImageModule
  ],
  providers: [],
})
export class PagesModule { }
